import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';

import { useAuth } from '@/hooks/useAuth';
import { apiRequest } from '@/lib/queryClient';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export function ClassWaitlistForm({ classId }: { classId: string }) {
  const { isAuthenticated } = useAuth();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const joinMutation = useMutation({
    mutationFn: async () => {
      await apiRequest(
        'POST',
        `/api/waitlist/classes/${classId}`,
        isAuthenticated ? undefined : { email, name: name || undefined }
      );
    },
    onSuccess: () => setSubmitted(true),
  });

  if (submitted) {
    return (
      <p className="text-center text-sm font-medium text-primary">
        You're on the waitlist — we'll email you when a new session is scheduled.
      </p>
    );
  }

  return (
    <form
      className="space-y-2"
      onSubmit={e => {
        e.preventDefault();
        joinMutation.mutate();
      }}
    >
      <p className="text-center text-xs font-medium text-muted-foreground">
        No upcoming sessions. Want us to let you know when one's scheduled?
      </p>
      {!isAuthenticated && (
        <>
          <Input
            type="email"
            required
            placeholder="your@email.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            className="rounded-full"
          />
          <Input
            type="text"
            placeholder="Your name (optional)"
            value={name}
            onChange={e => setName(e.target.value)}
            className="rounded-full"
          />
        </>
      )}
      <Button
        type="submit"
        className="w-full rounded-full px-5"
        disabled={joinMutation.isPending || (!isAuthenticated && !email)}
      >
        {joinMutation.isPending ? 'Joining…' : 'Notify me'}
      </Button>
      {joinMutation.isError && (
        <p className="text-center text-xs font-medium text-destructive">
          Something went wrong. Please try again.
        </p>
      )}
    </form>
  );
}
